import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="main-footer dark">
      <div className="container">
        <div className="row">
          <div className="col-md-5 mb-20">
            <div className="item fotcont">
              <div className="fotheadleft">
                <h6>Email</h6>
                <p>contact@placedrisk.com</p>
              </div>
            </div>
          </div>
          <div className="col-md-2 mb-10 abot" />
          <div className="col-md-5 mb-30 abot">
            <div className="item fotcont">
              <div className="fotheadright">
                <h6>Follow us</h6>
                <div className="social-icon">
                  <a href="https://www.linkedin.com/company/placedrisk-solutions/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="ti-linkedin" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sub-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="text-left">
                <p>© {new Date().getFullYear()} Placed Risk Pty Ltd. All Rights Reserved.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="text-center">
                <p>
                  Designed and Developed by{" "}
                  <a style={{ fontWeight: "bold" }} href="https://ollcode.com">
                    Ollcode
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <p className="right">
                <Link to="/privacypolicy">Privacy Policy</Link> &nbsp; &nbsp;
                <Link to="/termsconditions">Terms &amp; Conditions</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
